import React from 'react';
import { ClockIcon, LockIcon, MessageCircleIcon } from 'lucide-react';
import { Section } from '../ui/Section';
import { SectionTitle, Accent } from '../ui/SectionTitle';
import { CtaButton } from '../ui/CtaButton';
const reassurances = [{
  icon: ClockIcon,
  text: 'Toma menos de 2 minutos.'
}, {
  icon: MessageCircleIcon,
  text: 'Orientación en español.'
}, {
  icon: LockIcon,
  text: 'Tu información es confidencial.'
}];
export function DiagnosisFormSection() {
  return <Section id="diagnostico" tone="ink" data-id="element-99" data-mp="1l5u1r8fh2ofm">
      <div className="grid gap-12 lg:grid-cols-12 lg:items-end lg:gap-16" data-id="element-100" data-mp="1l6vle1ak0j8y">
        <div className="lg:col-span-7" data-id="element-101" data-mp="17eyxyajtyxiw">
          <SectionTitle data-id="element-102" data-mp="17g090f0ujk0m">
            Solicita tu Jseefect <Accent data-id="element-103" data-mp="1cda7sla4l814">Fitness Check gratis</Accent>
          </SectionTitle>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-muted" data-id="element-104" data-mp="1cb5w3h5zj4qa">
            Completa este formulario rápido para entender tu punto de partida. Después te llevaremos a WhatsApp para
            continuar con el siguiente paso.
          </p>
        </div>

        <div className="lg:col-span-5" data-id="element-105" data-mp="jnfquz2ob8lf">
          <ul className="space-y-4 border-t border-line pt-8" data-id="element-106" data-mp="jqk22gek34ll">
            {reassurances.map(({
            icon: Icon,
            text
          }) => <li key={text} className="flex items-center gap-3 text-white" data-id="element-107" data-mp="spxenhxz89aj">
                <Icon className="h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-108" data-mp="onu2er3hh0o7" />
                {text}
              </li>)}
          </ul>
          <CtaButton className="mt-8 w-full" data-id="element-109" data-mp="z13qmvh8epw">Quiero mi Fitness Check gratis</CtaButton>
        </div>
      </div>
    </Section>;
}